




























import Vue from "vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwGardenSurface from "@/encoding/pages/questions/exterior/GardenSurface.vue";
import iwGardenOrientation from "@/encoding/pages/questions/exterior/GardenOrientation.vue";

export default Vue.extend({
    components: {
        iwInputCheckboxGroup: iwInputCheckboxGroup,
        iwAccordion: iwAccordion,
        iwGardenSurface: iwGardenSurface,
        iwGardenOrientation: iwGardenOrientation
    },
    data: function() {
        return {
            pathInStoreExists: "property.outdoor.garden.exists",
            pathInStoreGardenSurface: "property.outdoor.garden.surface",
            pathInStoreGardenOrientation: "property.outdoor.garden.orientation",
            checkboxes: [
                {
                    value: "withGarden",
                    label: "with_garden"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "COMMERCIAL", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["withGarden"];
            }
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreGardenSurface) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreGardenOrientation);
        },
        isOpen: function(): boolean {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreExists);
        },
        gardenSurface: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreGardenSurface);
        },
        gardenSurfaceInput: function(): Vue | void {
            const accordionComponent = this.$refs.gardenSurface as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.gardenSurfaceInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        },
        gardenOrientation: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreGardenOrientation);
        }
    },
    mounted: function() {
        if (this.isDisplayed && this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStoreExists);
        }
    },
    methods: {
        updateValueGardenSurface: function(gardenSurface: number): void {
            if (gardenSurface == 0 && this.gardenSurface != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreGardenSurface);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreGardenSurface, "value": gardenSurface});
            }
        },
        updateValueGardenOrientation: function(value: string): void {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreGardenOrientation, "value": value});
            } else if (value == "" && this.gardenOrientation != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreGardenOrientation);
            }
        },
        updateValue: function(selectedValues: Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
                if(this.gardenSurface == null) {
                    this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreGardenSurface, value: 1});
                }
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.gardenSurfaceInput) {
                    this.gardenSurfaceInput.$data.internalInput = 1;
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreGardenSurface);
                this.$store.commit("FormModule/deleteValue", this.pathInStoreGardenOrientation);
            }
        }
    },
});

